import { render } from "./QReceipt.vue?vue&type=template&id=3d950e15"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QReceipt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d950e15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d950e15', __exports__)) {
    api.reload('3d950e15', __exports__)
  }
  
  module.hot.accept("./QReceipt.vue?vue&type=template&id=3d950e15", () => {
    api.rerender('3d950e15', render)
  })

}


export default __exports__